import { shellStringResources } from '../../Resources/ShellStringResources';
import { format, stringIsNullOrEmpty } from '../../shared/utils/string.util';
import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { ExpressCustomSetup, expressCustomSetupTypes } from './expressCustomSetup';

@Metamodel.model({
    name: 'CmdKeyCommand',
    display: [shellStringResources.ModelName_CmdKeyCommandExtension, shellStringResources.ModelName_CmdKeyCommandExtensions]
})
export class CmdkeyCommandSetup extends ExpressCustomSetup {
    public static readonly MODEL: IModel;

    public targetName: string;
    public userName: string;
    public password: string;

    constructor(name?: string, public description?: string) {
        super(expressCustomSetupTypes.Cmdkey, name, description);
    }

    public getCustomSetupName(): string {
        return format(shellStringResources.IRCreation_SSIS_CustomSetup_CmdKey_Format, this.targetName, this.userName);
    }

    public coincideWith(customSetup: ExpressCustomSetup): void {
        if (this.customSetupType === customSetup.customSetupType) {
            const setup = customSetup as CmdkeyCommandSetup;
            this.targetName = setup.targetName;
            this.userName = setup.userName;
            this.password = setup.password;
        }
    }

    public validate(): boolean {
        return this.isValidProperty(this.targetName) && this.isValidProperty(this.userName) && this.isValidProperty(this.password);
    }

    private isValidProperty(property: string): boolean {
        return !stringIsNullOrEmpty(property) && property.indexOf(' ') === -1;
    }
}
